import { useQuery } from '@tanstack/react-query'
import { useLocation } from '@tanstack/react-router'
import { isKnowledgeGraphRoute } from '@/lib/isKnowledgeGraphRoute'
import type { KnowledgeGraphRef } from '@/lib/knowledgeBaseApi'
import {
  knowledgeBaseGraphQueryOptions,
  publishedKnowledgeBasesQueryOptions,
} from '@/lib/queries'

/** GET /knowledge_bases/published — only on Graph View (`/business-knowledge`) or when explicitly enabled. */
export function usePublishedKnowledgeBasesQuery(options?: {
  enabled?: boolean
}) {
  const { pathname } = useLocation()
  const enabled = options?.enabled ?? isKnowledgeGraphRoute(pathname)
  return useQuery({
    ...publishedKnowledgeBasesQueryOptions,
    enabled,
  })
}

/**
 * GET /knowledge_bases/{kbId}/graph — while Graph View is active and a
 * published knowledge base is selected.
 */
export function useKnowledgeGraphQuery(
  kbId: string | null,
  options?: { enabled?: boolean; ref?: KnowledgeGraphRef },
) {
  const { pathname } = useLocation()
  const enabled =
    (options?.enabled ?? isKnowledgeGraphRoute(pathname)) && Boolean(kbId)
  const ref = options?.ref ?? 'published'
  return useQuery({
    ...knowledgeBaseGraphQueryOptions(kbId ?? '_', ref),
    enabled,
  })
}
